import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

import { ActivityApiRepository } from '../repositories/activity-api.repository';
import { ActivityCacheRepository } from '../repositories/activity-cache.repository';
import { ActivityInterface } from '../data';
import { Transaction } from '../transaction/transaction';

@Injectable()
export class ActivityProvider {
    constructor(private activityApiRepository: ActivityApiRepository, private activityCacheRepository: ActivityCacheRepository) {}

    find(): Observable<Transaction<ActivityInterface[]>> {
        return concat(
            this.activityCacheRepository.load(),
            this.activityApiRepository.load().pipe(
                tap((transaction) => {
                    if (transaction.isSuccess) {
                        this.activityCacheRepository.save(transaction.data).subscribe();
                    }
                })
            )
        ).pipe(first());
    }
}
